const getClassNameForLabel = (label) => {
  const OPERATION_REGEX = /[÷x\-+=]/;

  if (label === '0') {
    return 'zero-btn';
  } if (label === '+/-') {
    return '';
  } if (OPERATION_REGEX.test(label)) {
    return 'operation';
  }
  return '';
};

export default getClassNameForLabel;
